"use client";

import React from "react";
import { Helmet } from "react-helmet-async";
import { useMemo } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useState } from "react";
import { useMotionValue, useSpring, useTransform } from "framer-motion";
import { useScroll } from "framer-motion";
import { Link } from "react-router-dom";
import VideoCard from "../components/VideoCard";
import {
  HelpCircle,
  Zap,
  Battery,
  Clock,
  MapPin,
  ShieldCheck,
} from "lucide-react";
import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { FaSolarPanel, FaTools, FaPiggyBank } from "react-icons/fa";
import { ChevronLeft, ChevronRight } from "lucide-react";
import "swiper/css";
import "swiper/css/pagination";
import { useEffect } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const testimonials = [
  {
    name: "Sarah Johnson",
    role: "Homeowner – Ibadan, Nigeria",
    image: "/Assets/african-woman.jpg",
    content:
      "Since switching to Solar Surge, my monthly electricity bills have dropped drastically. The installation was smooth, and I haven't had a blackout since!",
  },
  {
    name: "Musa Ibrahim",
    role: "Real Estate Developer – Abuja, Nigeria",
    image: "/Assets/man.jpg",
    content:
      "We equipped 15 housing units with Solar Surge systems. Not only are our tenants happy, but the value of our properties has also increased. Highly recommend!",
  },
  {
    name: "Adebayo Kehinde",
    role: "Bakery Owner – Lagos, Nigeria",
    image: "/Assets/womportrait.jpg",
    content:
      "My bakery now runs 24/7 without fear of power outages. Solar Surge truly gave us power independence!",
  },
  {
    name: "Samuel Olonade",
    role: "Warehouse Owner – Lagos, Nigeria",
    image: "/Assets/warehouseman.jpg",
    content:
      "My bakery now runs 24/7 without fear of power outages. Solar Surge truly gave us power independence!",
  },
];

const faqs = [
  {
    question: "How much does solar panel installation cost in Lagos?",
    answer:
      "The cost depends on your energy needs and system size. Most of our clients in Lagos choose systems that balance affordability with long-term savings. We provide a free assessment to recommend the best option for your home or business.",
    icon: Zap,
  },
  {
    question: "Can solar power run my entire home or business?",
    answer:
      "Yes. We design custom systems that can power everything from essential appliances to full buildings. Our team ensures you get reliable, uninterrupted energy tailored to your usage.",
    icon: Battery,
  },
  {
    question: "How long does installation take?",
    answer:
      "Most installations are completed within 1–3 days. Our team works efficiently to minimize disruption while ensuring everything is installed to the highest standard.",
    icon: Clock,
  },
  {
    question: "Do you install across Lagos State?",
    answer:
      "Absolutely. We serve all major areas including Lekki, Ikeja, Ajah, and surrounding locations.",
    icon: MapPin,
  },
  {
    question: "Why choose Solaris Surge over other solar companies?",
    answer:
      "With over 10 years of experience, we combine quality products, expert installation, and reliable support.",
    icon: ShieldCheck,
  },
];

const headerVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

const iconVariants = {
  hidden: { scale: 0, rotate: -180 },
  visible: {
    scale: 1,
    rotate: 0,
    transition: { duration: 0.5, ease: "easeOut", delay: 0.2 },
  },
};

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.3,
      delayChildren: 0.2,
      duration: 0.6,
    },
  },
};

const introsVariants = {
  hidden: {
    opacity: 0,
    y: 30,
    scale: 0.95,
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.8,
      ease: [0.25, 0.46, 0.45, 0.94],
    },
  },
};

// const buttonVariants = {
//   hidden: {
//     opacity: 0,
//     y: 20,
//     scale: 0.9,
//   },
//   visible: {
//     opacity: 1,
//     y: 0,
//     scale: 1,
//     transition: {
//       duration: 0.6,
//       ease: "easeOut",
//     },
//   },
// };

// const cardsVariaants = {
//   hidden: { opacity: 0, y: 50 },
//   visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
// };

// const circleVariants = {
//   hidden: { opacity: 0, scale: 0 },
//   visible: { opacity: 1, scale: 1, transition: { duration: 0.8, delay: 0.3 } },
// };

// const cardsVariants = {
//   hidden: { opacity: 0, x: -50 }, // Initial state for left card
//   visible: {
//     opacity: 1,
//     x: 0,
//     transition: { type: "spring", stiffness: 80, damping: 15 }, // Smooth slide-in effect
//   },
// };

// const imageVariants = {
//   hidden: { opacity: 0, scale: 0.9 }, // Initial state for image
//   visible: {
//     opacity: 1,
//     scale: 1,
//     transition: { type: "spring", stiffness: 80, damping: 15 }, // Smooth zoom-in effect
//   },
// };

const formVariants = {
  hidden: { opacity: 0, y: 50 }, // Initial state for the form
  visible: {
    opacity: 1,
    y: 0,
    transition: { type: "spring", stiffness: 80, damping: 15 }, // Smooth slide-in effect
  },
};

const sectionVariants = {
  hidden: { opacity: 0, y: 50 }, // Start state (hidden)
  visible: {
    opacity: 1,
    y: 0,
    transition: { type: "spring", stiffness: 80, damping: 15 }, // Smooth entrance
  },
};

const cardVariantss = {
  hidden: { opacity: 0, y: 50, scale: 0.9 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

const servicesContainerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
      delayChildren: 0.1,
    },
  },
};

const servicesHeaderVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut",
    },
  },
};

const servicesCardVariants = {
  hidden: { opacity: 0, y: 50, scale: 0.95 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.7,
      ease: "easeOut",
    },
  },
};

const servicesFeatureVariants = {
  hidden: { opacity: 0, x: -20 },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.5,
      ease: "easeOut",
    },
  },
};

// const servicesIconVariants = {
//   hidden: { scale: 0, rotate: -180 },
//   visible: {
//     scale: 1,
//     rotate: 0,
//     transition: {
//       duration: 0.6,
//       ease: "easeOut",
//       type: "spring",
//       stiffness: 200,
//     },
//   },
// };

// const introSliderSettings = {
//   dots: true,
//   infinite: true,
//   speed: 500,
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   autoplay: true,
//   autoplaySpeed: 3000,
//   cssEase: "ease-in-out",
// };

const stepVariants = {
  hidden: (direction) => ({
    opacity: 0,
    x: direction > 0 ? 60 : -60,
    scale: 0.98,
  }),
  visible: {
    opacity: 1,
    x: 0,
    scale: 1,
    transition: {
      duration: 0.45,
      ease: [0.22, 1, 0.36, 1],
    },
  },
  exit: (direction) => ({
    opacity: 0,
    x: direction > 0 ? -60 : 60,
    scale: 0.98,
    transition: {
      duration: 0.25,
    },
  }),
};

const Home = () => {
  // ✅ STATES FIXED
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [modal, setModal] = useState({
    show: false,
    type: "",
    message: "",
  });

  const fullText =
    "Expert Solar Panel Installations for Homes & Businesses in Lagos, Nigeria";

  const chars = fullText.split("");

  // const [text, setText] = useState("");

  const { scrollY } = useScroll();

  const heroParallaxY = useTransform(scrollY, [0, 500], [0, -100]);
  // const sectionFadeY = useTransform(scrollY, [200, 800], [50, 0]);

  // const springMouseX = useSpring(mouseX, { stiffness: 150, damping: 15 });
  // const springMouseY = useSpring(mouseY, { stiffness: 150, damping: 15 });

  const [bubbleX, setBubbleX] = useState(0);

  const handleBubbleMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;

    const percent = (x / rect.width - 0.5) * 2;
    setBubbleX(percent);
  };

  const [bill, setBill] = useState(200);

  const systemSize = useMemo(() => {
    return (bill / 50).toFixed(1);
  }, [bill]);

  const savings = useMemo(() => {
    return Math.round(bill * 0.6);
  }, [bill]);

  // ================= TESTIMONIAL STATE =================
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () =>
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);

  const prevTestimonial = () =>
    setCurrentIndex(
      (prev) => (prev - 1 + testimonials.length) % testimonials.length,
    );

  // ================= 3D CAROUSEL FIX =================
  // const cardRefs = useRef([]);

  // const getRepulsion = (index) => {
  //   const distance = index - currentIndex;

  //   return {
  //     x: distance * 180,
  //     rotateY: distance * -35,
  //     scale: index === currentIndex ? 1 : 0.85,
  //     zIndex: index === currentIndex ? 10 : 5 - Math.abs(distance),
  //     opacity: Math.abs(distance) > 2 ? 0 : 1,
  //   };
  // };

  // const cards = testimonials || [];

  // ================= MAGNETIC EFFECT =================
  const useMagnetic = () => {
    const ref = useRef(null);

    const x = useMotionValue(0);
    const y = useMotionValue(0);

    const springX = useSpring(x, { stiffness: 150, damping: 15 });
    const springY = useSpring(y, { stiffness: 150, damping: 15 });

    const handleMouseMove = (e) => {
      const rect = ref.current?.getBoundingClientRect();
      if (!rect) return;

      const centerX = rect.left + rect.width / 2;
      const centerY = rect.top + rect.height / 2;

      const deltaX = e.clientX - centerX;
      const deltaY = e.clientY - centerY;

      x.set(deltaX * 0.2);
      y.set(deltaY * 0.2);
    };

    const handleMouseLeave = () => {
      x.set(0);
      y.set(0);
    };

    return {
      ref,
      style: {
        x: springX,
        y: springY,
      },
      handlers: {
        onMouseMove: handleMouseMove,
        onMouseLeave: handleMouseLeave,
      },
    };
  };

  const magnetic = useMagnetic();

  // ================= HAPTIC CLICK =================
  const handleHapticClick = (e) => {
    const el = e.currentTarget;

    el.animate(
      [
        { transform: "scale(1)", filter: "blur(0px)" },
        { transform: "scale(0.96)", filter: "blur(1px)" },
        { transform: "scale(1)", filter: "blur(0px)" },
      ],
      { duration: 180, easing: "ease-out" },
    );
  };

  // const hoverScale = { scale: 1.05 };
  // const tapScale = { scale: 0.95 };

  // const heroContainerVariants = {
  //   hidden: {},
  //   visible: {
  //     transition: { staggerChildren: 0.15 },
  //   },
  // };

  // const itemVariants = {
  //   hidden: { opacity: 0, y: 40 },
  //   visible: {
  //     opacity: 1,
  //     y: 0,
  //     transition: { duration: 0.6 },
  //   },
  // };

  // const floatingAnimation = {
  //   y: [0, -10, 0],
  //   transition: {
  //     duration: 5,
  //     repeat: Infinity,
  //     ease: "easeInOut",
  //   },
  // };

  // const glowX = useMotionValue(0);
  // const glowY = useMotionValue(0);

  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  const [isPaused, setIsPaused] = useState(false);

  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(1);
  const [direction, setDirection] = useState(1);

  const nextStep = () => {
    setDirection(1);
    setStep((s) => Math.min(s + 1, 3));
  };

  const prevStep = () => {
    setDirection(-1);
    setStep((s) => Math.max(s - 1, 1));
  };

  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, threshold: 0.1 });

  // ================= HANDLE CHANGE =================
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  // ================= HANDLE SUBMIT =================
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (loading) return;
    setLoading(true);

    setModal({ show: false, type: "", message: "" });

    if (!form.name || !form.email || !form.message) {
      setModal({
        show: true,
        type: "error",
        message: "Please fill in all fields.",
      });
      setLoading(false);
      return;
    }

    const emailRegex = /\S+@\S+\.\S+/;
    if (!emailRegex.test(form.email)) {
      setModal({
        show: true,
        type: "error",
        message: "Please enter a valid email.",
      });
      setLoading(false);
      return;
    }

    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 10000);

    try {
      const res = await fetch(
        "https://hooks.zapier.com/hooks/catch/26979240/unrorfw/",
        {
          method: "POST",
          body: JSON.stringify({
            name: form.name.trim(),
            email: form.email.trim(),
            message: form.message.trim(),
            subject: "Homepage Inquiry",
            phone: form.phone || "Not provided",
            source: "Homepage",
            status: "New Lead",
          }),
          signal: controller.signal,
        },
      );

      clearTimeout(timeout);

      if (!res.ok) throw new Error(`Server error: ${res.status}`);

      setModal({
        show: true,
        type: "success",
        message: "Message sent successfully!",
      });

      setForm({
        name: "",
        email: "",
        phone: "",
        message: "",
      });
    } catch (error) {
      setModal({
        show: true,
        type: "error",
        message:
          error.name === "AbortError"
            ? "Request timed out. Please try again."
            : "Something went wrong. Please try again.",
      });
    } finally {
      clearTimeout(timeout);
      setLoading(false);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 6000); // 6 seconds per testimonial

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (isPaused) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 6000);

    return () => clearInterval(interval);
  }, [isPaused]);

  return (
    <>
      <Navbar />
      <Helmet>
        {/* <div className="relative z-20 overflow-hidden"> */}

        <title>
          Solar Panels in Lagos Nigeria | Installation & Inverters - Solaris
          Surge
        </title>

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqs.map((faq) => ({
              "@type": "Question",
              name: faq.question,
              acceptedAnswer: {
                "@type": "Answer",
                text: faq.answer,
              },
            })),
          })}
        </script>

        <meta
          name="description"
          content="Looking for solar panels in Lagos? Solaris Surge provides affordable solar installation, inverters, and batteries for homes and businesses across Nigeria. Get reliable power solutions today."
        />
        <meta
          property="og:title"
          content="Solar Panels in Lagos Nigeria | Solaris Surge Energy"
        />
        <meta
          property="og:description"
          content="Reliable solar inverters and batteries for homes and businesses in Nigeria."
        />
        <meta property="og:url" content="https://www.solarissurge.net/" />
        <meta property="og:type" content="website" />
        {/* </div> */}
      </Helmet>
      <div className="relative z-20 overflow-hidden">
        {/* Intro Section */}
        <div className="relative flex items-center justify-center min-h-[65vh] sm:min-h-[75vh] lg:min-h-[90vh] px-6 md:px-12 lg:px-20 text-center">
          {/* Video Background */}
          <div className="absolute inset-0">
            <video
              autoPlay
              muted
              loop
              playsInline
              className="w-full h-full object-cover"
            >
              <source src="Assets/herosectionvideo.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            {/* Dark Gradient Overlay */}
            <div className="absolute inset-0 bg-black/60"></div>
          </div>
          {/* Content */}

          <motion.div
            style={{ y: heroParallaxY }}
            className="relative z-10 max-w-4xl mx-auto text-white space-y-6"
            variants={containerVariants}
            initial="hidden"
            animate="visible"
          >
            {/* 🌟 FLOATING BACKGROUND GLOW */}
            <motion.div
              className="absolute -top-20 left-1/2 -translate-x-1/2 w-[400px] h-[400px] bg-green-500/20 rounded-full blur-[120px]"
              animate={{
                y: [0, -30, 0],
                x: [0, 20, 0],
                scale: [1, 1.05, 1],
              }}
              transition={{
                duration: 10,
                repeat: Infinity,
                ease: "easeInOut",
              }}
            />
            {/* 🟢 HERO TITLE */}
            {/* const chars = fullText.split(""); */}
            <motion.h1 className="text-3xl sm:text-5xl lg:text-6xl font-bold tracking-tight max-w-4xl mx-auto px-2 sm:px-4 leading-tight sm:leading-snug lg:leading-[1.25]">
              {chars.map((char, i) => (
                <motion.span
                  key={i}
                  initial={{ opacity: 0, y: 10, filter: "blur(6px)" }}
                  animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                  transition={{
                    duration: 0.4,
                    delay: i * 0.03,
                    ease: "easeOut",
                  }}
                  style={{ display: "inline-block" }}
                >
                  {char === " " ? "\u00A0" : char}
                </motion.span>
              ))}

              <motion.span
                className="ml-1 text-green-500"
                animate={{ opacity: [0, 1, 0] }}
                transition={{ duration: 1, repeat: Infinity }}
              >
                |
              </motion.span>
            </motion.h1>
            {/* 🟡 DESCRIPTION */}
            <motion.p
              variants={introsVariants}
              className="text-base sm:text-lg lg:text-xl text-gray-200 max-w-2xl mx-auto leading-relaxed px-4"
            >
              With over{" "}
              <span className="font-bold">10 years of experience</span>, we
              deliver affordable, reliable solar energy solutions tailored to
              your needs.
            </motion.p>
            {/* 🔵 CTA BUTTONS */}
            <motion.div
              className="flex flex-wrap justify-center gap-4 mt-6"
              variants={introsVariants}
            >
              <motion.button
                ref={magnetic.ref}
                onClick={handleHapticClick}
                style={{
                  ...magnetic.style,
                  perspective: 1000,
                }}
                onMouseMove={(e) => {
                  magnetic.handlers.onMouseMove(e);
                  handleBubbleMove(e);
                }}
                onMouseLeave={magnetic.handlers.onMouseLeave}
                whileTap={{
                  scale: 0.92,
                  rotateX: 8,
                  rotateY: -8,
                }}
                className="relative overflow-hidden rounded-full px-8 py-3 font-bold text-white bg-green-600 shadow-2xl transform-gpu"
              >
                {/* 🌌 ambient cursor glow */}
                <motion.div
                  className="absolute inset-0"
                  style={{
                    background: `radial-gradient(circle at ${
                      bubbleX * 50 + 50
                    }% 50%, rgba(34,197,94,0.9), transparent 60%)`,
                  }}
                />

                {/* 🫧 LIQUID BUBBLES LAYER */}
                <motion.div
                  className="absolute inset-0 opacity-40"
                  animate={{
                    x: bubbleX * 20,
                  }}
                  transition={{ type: "spring", stiffness: 120, damping: 15 }}
                >
                  <div className="absolute w-32 h-32 bg-white/20 blur-2xl rounded-full top-1/2 left-1/4" />
                  <div className="absolute w-24 h-24 bg-green-300/30 blur-2xl rounded-full top-1/3 left-2/3" />
                  <div className="absolute w-28 h-28 bg-emerald-200/20 blur-2xl rounded-full bottom-0 left-1/2" />
                </motion.div>

                {/* ✨ reflection sweep */}
                <motion.span
                  className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent"
                  whileHover={{ x: ["-120%", "120%"] }}
                  transition={{ duration: 0.8 }}
                />

                {/* 💥 press shockwave */}
                <motion.span
                  className="absolute inset-0 rounded-full"
                  whileTap={{
                    scale: [1, 1.6],
                    opacity: [0.5, 0],
                  }}
                  transition={{ duration: 0.4 }}
                />

                {/* 🧠 content */}
                <span className="relative z-10">
                  <button
                    onClick={() =>
                      window.scrollTo({
                        top: document.body.scrollHeight,
                        behavior: "smooth",
                      })
                    }
                  >
                    Request a Free Quote
                  </button>
                </span>
              </motion.button>

              <motion.button
                ref={magnetic.ref}
                onClick={handleHapticClick}
                style={{
                  ...magnetic.style,
                  perspective: 1200,
                }}
                onMouseMove={(e) => {
                  magnetic.handlers.onMouseMove(e);
                  handleBubbleMove(e);
                }}
                onMouseLeave={magnetic.handlers.onMouseLeave}
                whileHover={{
                  scale: 1.06,
                  rotateX: 6,
                  rotateY: 6,
                }}
                whileTap={{
                  scale: 0.94,
                  rotateX: -6,
                }}
                className="relative overflow-hidden rounded-full px-8 py-3 font-bold text-green-600 bg-white shadow-2xl transform-gpu"
              >
                {/* 🌫 glass distortion layer */}
                <motion.div
                  className="absolute inset-0"
                  animate={{
                    background: [
                      "linear-gradient(120deg, #ffffff, #f0fdf4)",
                      "linear-gradient(120deg, #f0fdf4, #ffffff)",
                    ],
                  }}
                  transition={{
                    duration: 5,
                    repeat: Infinity,
                  }}
                />

                {/* 🫧 bubble flow */}
                <motion.div
                  className="absolute inset-0 opacity-30"
                  animate={{
                    x: bubbleX * -25,
                  }}
                  transition={{ type: "spring", stiffness: 100 }}
                >
                  <div className="absolute w-28 h-28 bg-green-200/30 blur-2xl rounded-full top-1/2 left-1/3" />
                  <div className="absolute w-20 h-20 bg-emerald-300/20 blur-2xl rounded-full bottom-1/4 right-1/3" />
                </motion.div>

                {/* ✨ sweep */}
                <motion.span
                  className="absolute inset-0 bg-gradient-to-r from-transparent via-green-200/40 to-transparent"
                  whileHover={{ x: ["-120%", "120%"] }}
                  transition={{ duration: 0.7 }}
                />

                {/* 🧠 content */}
                <span className="relative z-10">
                  <Link to="/contactsection">Get My Estimate</Link>
                </span>
              </motion.button>
            </motion.div>
            {/* 🔒 TRUST TEXT */}
            <motion.p
              variants={introsVariants}
              className="text-sm text-gray-300"
            >
              Your information is safe with us.{" "}
              <a
                href="/contact"
                className="underline hover:text-white transition-colors"
              >
                Privacy Policy
              </a>
            </motion.p>
          </motion.div>
        </div>
        {/* Blog Section */}
        <div className="relative bg-white py-24 overflow-hidden">
          {/* 🌌 ambient background glow */}
          <motion.div
            className="absolute inset-0"
            animate={{
              background: [
                "radial-gradient(circle at 20% 20%, rgba(34,197,94,0.12), transparent 40%)",
                "radial-gradient(circle at 80% 30%, rgba(16,185,129,0.10), transparent 45%)",
                "radial-gradient(circle at 50% 80%, rgba(34,197,94,0.08), transparent 50%)",
              ],
            }}
            transition={{ duration: 8, repeat: Infinity }}
          />

          {/* HEADER */}
          <motion.div
            ref={ref}
            variants={containerVariants}
            initial="hidden"
            animate={isInView ? "visible" : "hidden"}
            className="text-center mb-16 relative z-10"
          >
            <motion.h2
              variants={headerVariants}
              className="text-4xl sm:text-6xl font-bold tracking-tight text-black"
            >
              Why Choose Us
            </motion.h2>

            <motion.p
              variants={headerVariants}
              className="text-black/60 mt-5 max-w-2xl mx-auto text-lg leading-relaxed"
            >
              We're committed to delivering quality,
              <br className="sm:hidden" />
              reliability, and value in every project
            </motion.p>
          </motion.div>

          {/* CARDS */}
          <div className="max-w-6xl mx-auto px-6 relative z-10">
            <motion.div
              variants={containerVariants}
              initial="hidden"
              animate={isInView ? "visible" : "hidden"}
              className="grid grid-cols-1 md:grid-cols-3 gap-10"
            >
              {[
                {
                  icon: "fas fa-solar-panel",
                  title: "Expert Solar Installations",
                  text: "Over a decade of experience delivering efficient, long-lasting solar systems across Lagos, Nigeria.",
                },
                {
                  icon: "fas fa-leaf",
                  title: "Eco-Friendly Solutions",
                  text: "Sustainable energy products that help protect the planet while saving you money.",
                },
                {
                  icon: "fas fa-headset",
                  title: "Reliable Support",
                  text: "Dedicated customer service to guide you every step of the way.",
                },
              ].map((item, i) => (
                <motion.div
                  key={i}
                  variants={cardVariantss}
                  whileHover={{
                    scale: 1.03,
                    rotateX: 8,
                    rotateY: -8,
                    transition: { duration: 0.25 },
                  }}
                  whileTap={{ scale: 0.98 }}
                  className="relative p-8 rounded-3xl cursor-pointer transform-gpu overflow-hidden"
                >
                  {/* 🧊 glass layer */}
                  <div className="absolute inset-0 bg-white/60 backdrop-blur-2xl border border-black/5 rounded-3xl" />

                  {/* 🌊 light sweep */}
                  <motion.div
                    className="absolute inset-0"
                    whileHover={{ x: ["-120%", "120%"] }}
                    transition={{ duration: 0.9 }}
                    style={{
                      background:
                        "linear-gradient(90deg, transparent, rgba(34,197,94,0.12), transparent)",
                    }}
                  />

                  {/* ICON */}
                  <motion.div
                    variants={iconVariants}
                    className="relative z-10 mb-6 w-fit"
                    animate={{
                      y: [0, -6, 0],
                    }}
                    transition={{
                      duration: 4,
                      repeat: Infinity,
                      ease: "easeInOut",
                    }}
                  >
                    <div className="bg-black text-white p-4 rounded-2xl shadow-lg">
                      <i className={`${item.icon} text-lg`} />
                    </div>
                  </motion.div>

                  {/* TEXT */}
                  <div className="relative z-10">
                    <h3 className="text-xl font-semibold text-black mb-2">
                      {item.title}
                    </h3>
                    <p className="text-black/60 text-sm leading-relaxed">
                      {item.text}
                    </p>
                  </div>
                </motion.div>
              ))}
            </motion.div>
          </div>
        </div>
        <motion.div
          ref={ref}
          className="relative bg-white py-20 px-6 md:px-10 overflow-hidden"
          variants={servicesContainerVariants}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
        >
          {/* 🌈 AMBIENT BACKGROUND LIGHT */}
          <motion.div
            className="pointer-events-none absolute inset-0"
            animate={{
              background: [
                "radial-gradient(circle at 20% 30%, rgba(34,197,94,0.08), transparent 60%)",
                "radial-gradient(circle at 80% 40%, rgba(16,185,129,0.08), transparent 60%)",
                "radial-gradient(circle at 40% 80%, rgba(34,197,94,0.08), transparent 60%)",
              ],
            }}
            transition={{ duration: 10, repeat: Infinity }}
          />

          {/* ================= HEADER ================= */}
          <motion.div
            className="relative text-center mb-16 z-10"
            variants={servicesHeaderVariants}
          >
            <motion.span
              className="bg-lime-400 text-black text-xs font-semibold px-4 py-1.5 rounded-full uppercase tracking-widest shadow-sm"
              whileHover={{ scale: 1.08 }}
            >
              Services
            </motion.span>

            <motion.h2
              className="text-3xl sm:text-5xl font-extrabold text-black mt-6"
              variants={servicesHeaderVariants}
              animate={{
                y: [0, -6, 0],
              }}
              transition={{
                duration: 6,
                repeat: Infinity,
                ease: "easeInOut",
              }}
            >
              What we do.
            </motion.h2>

            <motion.p
              className="text-gray-700 mt-4 max-w-2xl mx-auto text-lg"
              variants={servicesHeaderVariants}
            >
              Our mission is simple: give you reliable, affordable, and
              future-ready solar solutions that save money, protect the planet,
              and keep your home running 24/7.
            </motion.p>
          </motion.div>

          {/* ================= CARDS ================= */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 max-w-6xl mx-auto relative z-10">
            {/* ================= LEFT CARD ================= */}
            <motion.div
              className="relative bg-white/70 backdrop-blur-xl border border-gray-200 p-8 rounded-3xl shadow-xl overflow-hidden"
              variants={servicesCardVariants}
              whileHover={{
                y: -10,
                scale: 1.03,
              }}
              transition={{ duration: 0.4 }}
            >
              {/* ✨ FLOATING LIGHT */}
              <motion.div
                className="absolute inset-0"
                animate={{
                  background: [
                    "radial-gradient(circle at 20% 20%, rgba(34,197,94,0.15), transparent 60%)",
                    "radial-gradient(circle at 80% 60%, rgba(16,185,129,0.15), transparent 60%)",
                  ],
                }}
                transition={{ duration: 6, repeat: Infinity }}
              />

              {/* FEATURE ITEM */}
              {[
                {
                  icon: <FaSolarPanel className="h-8 w-8" />,
                  title: "Complete Solar Solutions",
                  desc: "From panels to batteries, EV chargers, and AC units all in one place.",
                },
                {
                  icon: <FaTools className="h-8 w-8" />,
                  title: "Expert Installation Guaranteed",
                  desc: "Work with vetted professionals who install systems for maximum efficiency.",
                },
                {
                  icon: <FaPiggyBank className="h-8 w-8" />,
                  title: "Savings You Can Count On",
                  desc: "Lower your bills and enjoy predictable, low-cost energy for years.",
                },
              ].map((item, i) => (
                <motion.div
                  key={i}
                  className="flex items-start mb-6 last:mb-0 relative z-10"
                  variants={servicesFeatureVariants}
                  whileHover={{ x: 6 }}
                  transition={{ type: "spring", stiffness: 200 }}
                >
                  <motion.div
                    className="flex-shrink-0 text-orange-500 mr-4"
                    whileHover={{
                      scale: 1.15,
                      rotate: 8,
                    }}
                  >
                    {item.icon}
                  </motion.div>

                  <div>
                    <h3 className="text-lg font-bold text-black">
                      {item.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">{item.desc}</p>
                  </div>
                </motion.div>
              ))}
            </motion.div>

            {/* ================= VIDEO CARD ================= */}
            <motion.div
              className="relative bg-white/70 backdrop-blur-xl border border-gray-200 p-8 rounded-3xl shadow-xl flex flex-col items-center justify-center text-center overflow-hidden"
              variants={servicesCardVariants}
              whileHover={{
                y: -10,
                scale: 1.03,
              }}
              transition={{ duration: 0.4 }}
            >
              {/* 🎥 VIDEO FRAME FLOAT */}
              <motion.div
                className="w-full h-64 bg-black rounded-xl overflow-hidden mb-6 relative"
                animate={{
                  y: [0, -6, 0],
                }}
                transition={{
                  duration: 5,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
              >
                <VideoCard />
              </motion.div>

              <h3 className="text-lg font-bold text-black mb-2">
                See Solar in Action
              </h3>

              <p className="text-gray-600 leading-relaxed max-w-md mx-auto">
                Discover how our solar solutions transform homes and businesses
                with clean, efficient energy that works for you 24/7.
              </p>

              {/* ✨ LIGHT SWEEP */}
              <motion.div
                className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent"
                whileHover={{ x: ["-100%", "100%"] }}
                transition={{ duration: 1 }}
              />
            </motion.div>
          </div>
        </motion.div>
        <motion.div
          className="relative bg-white py-20 px-6 md:px-10 text-center overflow-hidden"
          initial={{ opacity: 0, y: 80 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          {/* 🌈 AMBIENT LIGHT SYSTEM */}
          <motion.div
            className="absolute inset-0 pointer-events-none"
            animate={{
              background: [
                "radial-gradient(circle at 20% 30%, rgba(34,197,94,0.08), transparent 60%)",
                "radial-gradient(circle at 80% 50%, rgba(16,185,129,0.08), transparent 60%)",
                "radial-gradient(circle at 40% 80%, rgba(34,197,94,0.08), transparent 60%)",
              ],
            }}
            transition={{ duration: 12, repeat: Infinity }}
          />

          {/* 🟢 BADGE */}
          <motion.span
            className="relative bg-lime-400 text-black text-xs font-bold px-4 py-1.5 rounded-full uppercase tracking-widest shadow-sm z-10"
            whileHover={{ scale: 1.08 }}
          >
            Services
          </motion.span>

          {/* 🧠 TITLE */}
          <motion.h2
            className="text-4xl md:text-5xl font-extrabold mt-6 relative z-10"
            animate={{ y: [0, -6, 0] }}
            transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
          >
            Our Services
          </motion.h2>

          <motion.p
            className="text-gray-600 mt-3 text-lg max-w-2xl mx-auto relative z-10"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
          >
            We provide top-notch solar installation, energy audits, and
            maintenance to keep your power reliable and sustainable.
          </motion.p>

          {/* ================= MAIN BLOCK ================= */}
          <motion.div
            className="relative bg-white/70 backdrop-blur-xl border border-gray-200 mt-12 max-w-5xl mx-auto rounded-3xl shadow-2xl p-10 md:flex md:items-center md:gap-10 overflow-hidden"
            whileHover={{
              scale: 1.02,
              y: -8,
            }}
            transition={{ duration: 0.4 }}
          >
            {/* ✨ INTERNAL LIGHT */}
            <motion.div
              className="absolute inset-0"
              animate={{
                background: [
                  "radial-gradient(circle at 30% 20%, rgba(34,197,94,0.12), transparent 60%)",
                  "radial-gradient(circle at 70% 80%, rgba(16,185,129,0.12), transparent 60%)",
                ],
              }}
              transition={{ duration: 8, repeat: Infinity }}
            />

            {/* 🎥 VIDEO SIDE */}
            <motion.div
              className="md:w-1/2 mb-6 md:mb-0 relative z-10"
              initial={{ opacity: 0, x: -60 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.7 }}
            >
              <motion.div
                className="w-full aspect-video bg-gray-200 rounded-xl overflow-hidden shadow-lg relative"
                animate={{
                  y: [0, -6, 0],
                }}
                transition={{
                  duration: 5,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
              >
                {/* ✨ VIDEO GLOW */}
                <motion.div
                  className="absolute inset-0 z-10 pointer-events-none"
                  animate={{
                    background: [
                      "radial-gradient(circle at 30% 30%, rgba(255,255,255,0.15), transparent 60%)",
                      "radial-gradient(circle at 70% 70%, rgba(255,255,255,0.1), transparent 60%)",
                    ],
                  }}
                  transition={{ duration: 6, repeat: Infinity }}
                />

                <iframe
                  className="w-full h-full"
                  src="https://www.youtube.com/embed/FxrjvVdZzD4?si=vgzQqnalSJL3gih-"
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                />
              </motion.div>
            </motion.div>

            {/* 📝 TEXT SIDE */}
            <motion.div
              className="md:w-1/2 text-left relative z-10"
              initial={{ opacity: 0, x: 60 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.7 }}
            >
              <h3 className="text-xl font-bold text-gray-800 mb-4">
                Solar Panel Installation in Lagos, Nigeria
              </h3>

              <p className="text-gray-700 mb-6">
                From small residential projects to large commercial systems, we
                specialize in delivering efficient and affordable solar
                solutions tailored to your needs.
              </p>

              {/* 🚀 CINEMATIC BUTTON */}
              <motion.button
                whileHover={{
                  scale: 1.05,
                  y: -3,
                }}
                whileTap={{
                  scale: 0.94,
                }}
                className="relative overflow-hidden bg-white border border-gray-300 rounded-full px-6 py-2 font-medium text-gray-800 shadow-md"
              >
                {/* ✨ SWEEP LIGHT */}
                <motion.span
                  className="absolute inset-0 bg-gradient-to-r from-transparent via-black/10 to-transparent"
                  whileHover={{ x: ["-120%", "120%"] }}
                  transition={{ duration: 0.8 }}
                />

                {/* 💡 GLOW CORE */}
                <motion.span
                  className="absolute inset-0"
                  animate={{
                    background: [
                      "radial-gradient(circle at 20% 50%, rgba(0,0,0,0.05), transparent 70%)",
                      "radial-gradient(circle at 80% 50%, rgba(0,0,0,0.05), transparent 70%)",
                    ],
                  }}
                  transition={{ duration: 4, repeat: Infinity }}
                />

                <span className="relative z-10">Learn more</span>
              </motion.button>
            </motion.div>
          </motion.div>
        </motion.div>
        <motion.div
          variants={sectionVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.3 }}
          className="bg-white py-12 px-5 md:px-10"
        >
          <div className="max-w-7xl mx-auto text-center">
            <h2 className="text-green-600 uppercase text-sm font-semibold">
              Best Sellers
            </h2>
            <h1 className="text-3xl font-bold text-gray-800 mt-2">
              Our Top-Selling Solar Packages in Lagos, Nigeria
            </h1>
            <p className="text-gray-600 mt-4 max-w-2xl mx-auto">
              Power your home or business across Lagos State with our most
              popular and trusted solar solutions. Limited-time offers
              available. shop now before stock runs out.
            </p>
          </div>

          {/* Products Grid */}
          <div className="max-w-7xl mx-auto grid sm:grid-cols-2 lg:grid-cols-3 gap-8 mt-14 perspective-[1200px]">
            {[1, 2, 3].map((_, index) => (
              <motion.div
                key={index}
                variants={sectionVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.3 }}
                whileHover={{
                  rotateX: -6,
                  rotateY: 6,
                  y: -12,
                  scale: 1.03,
                }}
                transition={{ type: "spring", stiffness: 120, damping: 15 }}
                className="relative bg-gray-100 rounded-xl p-5 flex flex-col overflow-hidden group"
              >
                {/* 🌈 dynamic glow */}
                <motion.div
                  className="absolute inset-0 opacity-0 group-hover:opacity-100 transition duration-500"
                  style={{
                    background:
                      "radial-gradient(circle at 50% 50%, rgba(34,197,94,0.25), transparent 70%)",
                  }}
                />

                {/* 🧊 floating image */}
                <motion.img
                  src={
                    index === 0
                      ? "/Assets/haisic3.jpg"
                      : index === 1
                        ? "/Assets/1.5KW Solar Energy System 1.8KVA gcl-12100.webp"
                        : "/Assets/4KW Solar Energy System 4KVA LBD-24200C.webp"
                  }
                  alt="product"
                  className="w-full h-48 object-cover rounded-lg"
                  whileHover={{ scale: 1.08 }}
                  transition={{ duration: 0.4 }}
                />

                {/* ✨ content */}
                <motion.div
                  className="mt-4 flex flex-col flex-grow relative z-10"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                >
                  <h3 className="text-lg font-semibold text-gray-800">
                    {index === 0
                      ? "Haisic All in one 4KVA 8kwh Lithium batteries"
                      : index === 1
                        ? "Complete Solar Kit"
                        : "Solar Inverter System"}
                  </h3>

                  <p className="text-gray-600 text-sm mt-2 flex-grow">
                    {index === 0
                      ? "Reliable on-grid solution for apartments with up to 8 hours backup."
                      : index === 1
                        ? "All-in-one solar package for homes and businesses."
                        : "High-efficiency inverter to maximize solar output."}
                  </p>

                  {/* ⚡ CTA button */}
                  <motion.div
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className="mt-5"
                  >
                    <Link
                      to="/shopsection"
                      className="relative inline-block bg-green-600 text-white py-2 px-5 rounded-full font-medium overflow-hidden"
                    >
                      {/* ✨ sweep effect */}
                      <span className="absolute inset-0 bg-gradient-to-r from-transparent via-white/40 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition duration-700" />

                      <span className="relative z-10">Shop Now</span>
                    </Link>
                  </motion.div>
                </motion.div>
              </motion.div>
            ))}
          </div>

          {/* Flash Sale Banner */}
          <motion.div
            className="max-w-7xl mx-auto mt-16 rounded-2xl p-8 text-center text-white relative overflow-hidden"
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6 }}
          >
            {/* 🔥 animated background energy */}
            <motion.div
              className="absolute inset-0"
              animate={{
                background: [
                  "linear-gradient(120deg, #f97316, #fb923c)",
                  "linear-gradient(120deg, #fb923c, #f97316)",
                ],
              }}
              transition={{ duration: 4, repeat: Infinity }}
            />

            <div className="relative z-10">
              <h3 className="text-2xl font-bold">
                ⚡ Flash Sale — This Week Only!
              </h3>

              <p className="mt-2 text-white/90">
                Get up to 15% off selected solar products. Hurry, offer ends
                soon!
              </p>

              <motion.div
                whileHover={{ scale: 1.08 }}
                whileTap={{ scale: 0.95 }}
                className="mt-5"
              >
                <button
                  onClick={() =>
                    window.scrollTo({
                      top: document.body.scrollHeight,
                      behavior: "smooth",
                    })
                  }
                  className="inline-block bg-white text-orange-600 py-2 px-6 rounded-full font-semibold shadow-lg"
                >
                  Browse Deals
                </button>
              </motion.div>
            </div>
          </motion.div>
        </motion.div>
        <motion.section
          {...magnetic.handlers}
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
          className="bg-gray-50 py-20 md:py-24 px-6 relative overflow-hidden"
        >
          {/* ambient background */}
          <motion.div
            className="absolute inset-0"
            animate={{ opacity: [0.4, 0.7, 0.4] }}
            transition={{ duration: 10, repeat: Infinity }}
          />

          {/* HEADER */}
          <div className="max-w-6xl mx-auto text-center mb-14 relative z-10">
            <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900">
              <span className="block text-gray-400 text-xl mb-2">
                Real Stories
              </span>
              What our customers are saying
            </h2>
          </div>

          {/* FEATURED CARD */}
          <div className="max-w-4xl mx-auto relative z-10">
            <motion.div
              key={currentIndex}
              initial={{ opacity: 0, y: 20, scale: 0.98 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              transition={{ duration: 0.5 }}
              className="bg-white rounded-3xl shadow-xl border border-gray-100 p-8 md:p-10 relative overflow-hidden"
            >
              {/* PROGRESS BAR */}
              <div className="absolute top-0 left-0 w-full h-1 bg-gray-100">
                <motion.div
                  className="h-full bg-green-500"
                  initial={{ width: "0%" }}
                  animate={{ width: "100%" }}
                  transition={{
                    duration: 6,
                    ease: "linear",
                    repeat: Infinity,
                  }}
                />
              </div>

              {/* CONTENT */}
              <div className="flex items-center gap-4 mb-6 mt-2">
                <img
                  alt="preview"
                  src={testimonials[currentIndex].image}
                  className="w-14 h-14 rounded-full object-cover"
                />

                <div>
                  <h3 className="font-bold text-gray-900">
                    {testimonials[currentIndex].name}
                  </h3>
                  <p className="text-gray-500 text-sm">
                    {testimonials[currentIndex].role}
                  </p>
                </div>
              </div>

              <p className="text-gray-700 text-lg leading-relaxed">
                “{testimonials[currentIndex].content}”
              </p>
            </motion.div>
          </div>

          {/* THUMBNAIL STRIP */}
          <div className="mt-12 relative z-10">
            <div className="flex gap-4 overflow-x-auto pb-4 px-2 snap-x snap-mandatory scroll-smooth">
              {testimonials.map((item, index) => {
                const isActive = index === currentIndex;

                return (
                  <motion.div
                    key={index}
                    onClick={() => setCurrentIndex(index)}
                    whileHover={{ scale: 1.05 }}
                    className={`min-w-[220px] md:min-w-[260px] snap-center cursor-pointer rounded-2xl p-4 border transition-all ${
                      isActive
                        ? "bg-green-50 border-green-400 shadow-md"
                        : "bg-white border-gray-100"
                    }`}
                  >
                    <div className="flex items-center gap-3">
                      <img
                        alt="preview"
                        src={item.image}
                        className="w-10 h-10 rounded-full object-cover"
                      />

                      <div className="overflow-hidden">
                        <h4 className="font-semibold text-gray-900 text-sm truncate">
                          {item.name}
                        </h4>
                        <p className="text-gray-500 text-xs truncate">
                          {item.role}
                        </p>
                      </div>
                    </div>
                  </motion.div>
                );
              })}
            </div>
          </div>

          {/* CONTROLS */}
          <div className="flex justify-center mt-10 gap-6 relative z-10">
            <motion.button
              onClick={prevTestimonial}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
              className="bg-white/80 backdrop-blur-md p-3 rounded-full shadow-lg"
            >
              <ChevronLeft className="w-5 h-5 text-gray-700" />
            </motion.button>

            <motion.button
              onClick={nextTestimonial}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
              className="bg-white/80 backdrop-blur-md p-3 rounded-full shadow-lg"
            >
              <ChevronRight className="w-5 h-5 text-gray-700" />
            </motion.button>
          </div>
        </motion.section>
        {/* </div> */}
        <div className="w-full px-4 sm:px-6 lg:px-8 py-14">
          <div className="max-w-6xl mx-auto">
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-green-950 via-green-900 to-green-800 shadow-2xl"
            >
              {/* glow */}
              <div className="absolute -top-20 -right-20 w-80 h-80 bg-orange-500/20 blur-3xl rounded-full" />
              <div className="absolute -bottom-20 -left-20 w-80 h-80 bg-green-400/20 blur-3xl rounded-full" />

              <div className="grid lg:grid-cols-2 gap-10 p-10 relative z-10 items-center">
                {/* LEFT */}
                <div>
                  <h2 className="text-3xl sm:text-4xl font-bold text-white leading-tight">
                    Calculate your
                    <span className="text-orange-400"> solar savings</span> in
                    seconds
                  </h2>

                  <p className="mt-3 text-white/70">
                    Adjust your monthly electricity bill to see your estimated
                    solar savings instantly.
                  </p>

                  {/* INPUT */}
                  <div className="mt-6">
                    <label className="text-white/80 text-sm">
                      Monthly Electricity Bill ($)
                    </label>

                    <input
                      type="range"
                      min="50"
                      max="500"
                      value={bill}
                      onChange={(e) => setBill(Number(e.target.value))}
                      className="w-full mt-2 accent-orange-500"
                    />

                    <div className="flex justify-between text-white/60 text-sm mt-2">
                      <span>$50</span>
                      <span className="text-orange-400 font-semibold">
                        ${bill}
                      </span>
                      <span>$500</span>
                    </div>
                  </div>

                  {/* RESULTS */}
                  <div className="mt-8 grid grid-cols-2 gap-4">
                    <motion.div
                      key={systemSize}
                      initial={{ scale: 0.9, opacity: 0 }}
                      animate={{ scale: 1, opacity: 1 }}
                      className="bg-white/10 backdrop-blur-md rounded-xl p-4 text-center"
                    >
                      <p className="text-white/60 text-sm">System Size</p>
                      <p className="text-2xl font-bold text-white">
                        {systemSize} kW
                      </p>
                    </motion.div>

                    <motion.div
                      key={savings}
                      initial={{ scale: 0.9, opacity: 0 }}
                      animate={{ scale: 1, opacity: 1 }}
                      className="bg-white/10 backdrop-blur-md rounded-xl p-4 text-center"
                    >
                      <p className="text-white/60 text-sm">Monthly Savings</p>
                      <p className="text-2xl font-bold text-orange-400">
                        ${savings}
                      </p>
                    </motion.div>
                  </div>

                  {/* CTA */}
                  <motion.a
                    href="/contactsection"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className="inline-block mt-8 bg-orange-500 hover:bg-orange-600 text-white py-3 px-8 rounded-full font-semibold shadow-lg"
                  >
                    Get My Full Solar Report
                  </motion.a>
                </div>

                {/* RIGHT VISUAL */}
                <div className="relative flex items-center justify-center">
                  {/* animated sun core */}
                  <motion.div
                    animate={{
                      scale: [1, 1.1, 1],
                      rotate: 360,
                    }}
                    transition={{
                      duration: 12,
                      repeat: Infinity,
                      ease: "linear",
                    }}
                    className="w-56 h-56 rounded-full bg-gradient-to-br from-orange-400 to-yellow-300 blur-sm opacity-90"
                  />

                  {/* energy rings */}
                  <motion.div
                    animate={{ rotate: -360 }}
                    transition={{
                      duration: 20,
                      repeat: Infinity,
                      ease: "linear",
                    }}
                    className="absolute w-72 h-72 border border-white/20 rounded-full"
                  />

                  <motion.div
                    animate={{ rotate: 360 }}
                    transition={{
                      duration: 25,
                      repeat: Infinity,
                      ease: "linear",
                    }}
                    className="absolute w-96 h-96 border border-orange-300/20 rounded-full"
                  />

                  {/* center icon */}
                  <div className="absolute w-16 h-16 bg-white rounded-full flex items-center justify-center shadow-xl">
                    <span className="text-green-800 font-bold">⚡</span>
                  </div>

                  {/* floating savings indicator */}
                  <motion.div
                    animate={{ y: [0, -10, 0] }}
                    transition={{
                      duration: 3,
                      repeat: Infinity,
                    }}
                    className="absolute bottom-6 bg-white/10 text-white px-4 py-2 rounded-full text-sm backdrop-blur-md"
                  >
                    Save up to 60% monthly
                  </motion.div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
        <div className="max-w-lg mx-auto mb-8 px-4">
          <div className="h-2 bg-gray-200 rounded-full overflow-hidden relative">
            {/* animated fill */}
            <div
              className="h-full bg-green-600 rounded-full transition-all duration-500 ease-in-out"
              style={{
                width: `${(step / 3) * 100}%`,
              }}
            />

            {/* optional glow effect */}
            <div
              className="absolute top-0 left-0 h-full bg-green-400 opacity-30 blur-md transition-all duration-500"
              style={{
                width: `${(step / 3) * 100}%`,
              }}
            />
          </div>

          {/* step labels (optional but premium feel) */}
          <div className="flex justify-between text-xs text-gray-500 mt-2 px-1">
            <span className={step >= 1 ? "text-green-600 font-medium" : ""}>
              Info
            </span>
            <span className={step >= 2 ? "text-green-600 font-medium" : ""}>
              Message
            </span>
            <span className={step >= 3 ? "text-green-600 font-medium" : ""}>
              Review
            </span>
          </div>
        </div>
        <section className="bg-gradient-to-b from-gray-50 to-white py-24 px-6">
          <div className="max-w-5xl mx-auto">
            {/* Header */}
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900">
                Frequently Asked Questions
              </h2>
              <p className="text-gray-600 mt-4 text-lg max-w-2xl mx-auto">
                Everything you need to know before switching to solar in Lagos,
                Nigeria.
              </p>
            </div>

            {/* FAQ Cards */}
            <div className="space-y-6">
              {faqs.map((faq, index) => {
                const isOpen = activeIndex === index;

                return (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4, delay: index * 0.1 }}
                    className="backdrop-blur-xl bg-white/70 border border-white/30 rounded-2xl shadow-lg overflow-hidden"
                  >
                    {/* Question */}
                    <button
                      onClick={() => toggleFAQ(index)}
                      className="w-full flex justify-between items-center p-6 text-left group"
                    >
                      <div className="flex items-center gap-4">
                        {/* Icon */}
                        <div className="w-10 h-10 flex items-center justify-center rounded-full bg-green-100 text-green-600 group-hover:bg-green-600 group-hover:text-white transition">
                          <HelpCircle className="w-5 h-5" />
                        </div>

                        <span className="font-semibold text-gray-900 text-lg group-hover:text-green-600 transition">
                          {faq.question}
                        </span>
                      </div>

                      {/* Arrow */}
                      <motion.span
                        animate={{ rotate: isOpen ? 180 : 0 }}
                        transition={{ duration: 0.3 }}
                        className="text-gray-500"
                      >
                        ▼
                      </motion.span>
                    </button>

                    {/* Answer */}
                    <motion.div
                      initial={false}
                      animate={{
                        height: isOpen ? "auto" : 0,
                        opacity: isOpen ? 1 : 0,
                      }}
                      transition={{ duration: 0.35 }}
                      className="overflow-hidden"
                    >
                      <div className="px-6 pb-6 text-gray-600 leading-relaxed">
                        {faq.answer}

                        {/* Subtle CTA inside answer */}
                        {index === 0 && (
                          <div className="mt-4">
                            <Link
                              to="/contactsection"
                              className="inline-block text-green-600 font-medium hover:underline"
                            >
                              Get a free quote →
                            </Link>
                          </div>
                        )}
                      </div>
                    </motion.div>
                  </motion.div>
                );
              })}
            </div>

            {/* Bottom CTA */}
            <div className="text-center mt-16">
              <p className="text-gray-700 mb-4">
                Still have questions? Let’s help you get started.
              </p>
              <Link
                to="/contactsection"
                className="inline-block bg-green-600 hover:bg-green-700 text-white px-8 py-3 rounded-full font-semibold shadow-lg transition"
              >
                Speak with an Expert
              </Link>
            </div>
          </div>
        </section>
        {/* Contact Form Section */}
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.3 }} // Trigger animation when 30% of the section is visible
          variants={formVariants}
          className="bg-green-10 py-12"
        >
          <div className="text-center mb-8">
            <h2 className="text-4xl font-bold text-gray-900">Get in Touch</h2>
            <p className="text-base sm:text-lg text-gray-600">
              Have questions or need more information? Reach out to us today!
            </p>
          </div>
          <div className="w-full max-w-4xl mx-auto px-6 py-10">
            <form onSubmit={handleSubmit} className="w-full">
              {/* STEP 1 */}
              {step === 1 && (
                <motion.div
                  custom={direction}
                  variants={stepVariants}
                  initial="hidden"
                  animate="visible"
                  exit="exit"
                  className="w-full flex justify-center"
                >
                  <div className="w-full max-w-lg space-y-6 mx-auto">
                    <input
                      name="name"
                      value={form.name}
                      onChange={handleChange}
                      placeholder="Name"
                      className="w-full p-4 border rounded-lg focus:ring-2 focus:ring-green-500 transition-all duration-300 focus:scale-[1.02] focus:outline-none"
                    />

                    <input
                      name="email"
                      value={form.email}
                      onChange={handleChange}
                      placeholder="Email"
                      className="w-full p-4 border rounded-lg focus:ring-2 focus:ring-green-500 transition-all duration-300 focus:scale-[1.02] focus:outline-none"
                    />

                    <div className="flex justify-end">
                      <button
                        type="button"
                        onClick={nextStep}
                        className="bg-green-600 text-white px-6 py-2 rounded-lg hover:scale-105 transition"
                      >
                        Next
                      </button>
                    </div>
                  </div>
                </motion.div>
              )}

              {/* STEP 2 */}
              {step === 2 && (
                <motion.div
                  custom={direction}
                  variants={stepVariants}
                  initial="hidden"
                  animate="visible"
                  exit="exit"
                  className="w-full flex justify-center"
                >
                  <div className="w-full max-w-lg space-y-6 mx-auto">
                    <input
                      name="phone"
                      value={form.phone}
                      onChange={handleChange}
                      placeholder="Phone (optional)"
                      className="w-full p-4 border rounded-lg focus:ring-2 focus:ring-green-500 transition-all duration-300 focus:scale-[1.02] focus:outline-none"
                    />

                    <textarea
                      name="message"
                      value={form.message}
                      onChange={handleChange}
                      placeholder="Your message"
                      className="w-full p-4 border rounded-lg h-32 focus:ring-2 focus:ring-green-500 transition-all duration-300 focus:scale-[1.02] focus:outline-none"
                    />

                    <div className="flex justify-between">
                      <button
                        type="button"
                        onClick={prevStep}
                        className="border px-4 py-2 rounded-lg"
                      >
                        Back
                      </button>

                      <button
                        type="button"
                        onClick={nextStep}
                        className="bg-green-600 text-white px-6 py-2 rounded-lg"
                      >
                        Review
                      </button>
                    </div>
                  </div>
                </motion.div>
              )}

              {/* STEP 3 */}
              {step === 3 && (
                <motion.div
                  custom={direction}
                  variants={stepVariants}
                  initial="hidden"
                  animate="visible"
                  exit="exit"
                  className="w-full flex justify-center"
                >
                  <div className="w-full max-w-lg space-y-4 border p-6 rounded-xl bg-white shadow-sm">
                    <h2 className="text-xl font-bold">Review</h2>

                    <p>
                      <strong>Name:</strong> {form.name}
                    </p>
                    <p>
                      <strong>Email:</strong> {form.email}
                    </p>
                    <p>
                      <strong>Phone:</strong> {form.phone || "N/A"}
                    </p>
                    <p>
                      <strong>Message:</strong> {form.message}
                    </p>

                    <div className="flex justify-between mt-6">
                      <button
                        type="button"
                        onClick={prevStep}
                        className="border px-4 py-2 rounded-lg"
                      >
                        Back
                      </button>

                      <button
                        type="button"
                        onClick={handleSubmit}
                        disabled={loading}
                        className="bg-green-600 text-white px-6 py-2 rounded-lg"
                      >
                        {loading ? "Sending..." : "Submit"}
                      </button>
                    </div>
                  </div>
                </motion.div>
              )}
            </form>
          </div>
        </motion.div>
        {modal.show && (
          <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-xl w-[90%] max-w-md text-center">
              <h2 className="text-xl font-bold mb-2">
                {modal.type === "success" ? "🎉 Success" : "⚠️ Error"}
              </h2>

              <p className="text-gray-600 mb-4">{modal.message}</p>

              <button
                onClick={() => setModal({ show: false, type: "", message: "" })}
                className="bg-green-600 text-white px-6 py-2 rounded"
              >
                Close
              </button>
            </div>
          </div>
        )}
        {/* Footer */}
        <a
          href="https://wa.me/+2348165213568?text=Hi!%20I%20have%20a%20query."
          target="_blank"
          rel="noopener noreferrer"
          className="fixed bottom-4 right-4 bg-green-500 p-3 rounded-full shadow-lg hover:bg-green-200"
        >
          <img
            src="/Assets/speak.png" // <-- Replace this with the actual image path or URL from Flaticon
            alt="WhatsApp Chat"
            className="w-8 h-8" // Tailwind sizes (e.g., w-6 = 24px)
          />
        </a>
        {modal.show && (
          <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-xl w-[90%] max-w-md text-center animate-fadeIn">
              <h2 className="text-xl font-bold mb-2">
                {modal.type === "success" ? "🎉 Success" : "⚠️ Error"}
              </h2>

              <p className="text-gray-600 mb-4">{modal.message}</p>

              <button
                onClick={() => setModal({ show: false, type: "", message: "" })}
                className="bg-green-600 text-white px-6 py-2 rounded"
              >
                Close
              </button>
            </div>
          </div>
        )}
        <Footer />
      </div>
    </>
  );
};

export default Home;
